import { Box, HStack, Header, Text } from '@rbilabs/universal-components';

import { theme } from 'styles/configure-theme';

export const DeliveryCardContainer = Box.withConfig({
  alignItems: 'center',
  width: 'full',
  padding: '$4',

  _text: {
    textAlign: 'left',
  },

  backgroundColor: {
    base: Styles.color.grey.five,
    md: 'none',
  },
});

export const Card = Box.withConfig({
  padding: '22px',
  margin: 0,
  marginBottom: '$4',
  width: 'full',
  backgroundColor: theme.token('background-pattern'),
  borderTopLeftRadius: Styles.borderRadius,
  borderTopRightRadius: Styles.borderRadius,
  borderBottomRightRadius: Styles.borderRadius,
  borderBottomLeftRadius: Styles.borderRadius,

  style: {
    shadowColor: Styles.shadowColor,
    shadowOffset: {
      width: 0,
      height: 0.5,
    },
    shadowRadius: 1.5,
    shadowOpacity: 1,
  },
  focusable: true,
});

export const ETA = Text.withConfig({
  fontSize: 'sm',
  paddingX: 0,
  paddingY: '$3',
  marginTop: '-12px',
  marginRight: 0,
  marginBottom: '$3',
  marginLeft: 0,
  borderBottomWidth: 1,
  borderBottomColor: Styles.color.grey.four,
});

export const CardHeading = Header.withConfig({
  color: Styles.color.black,
  fontFamily: Styles.fontFamily.base,
  fontSize: 'lg',
  lineHeight: 'md',
  padding: 0,
  margin: 0,
  marginBottom: '$4',
  textTransform: 'uppercase',
  variant: 'headerFour',
});

export const CardHeadingContainer = Box.withConfig({
  focusable: true,
});

export const TextGroup = Box.withConfig({
  borderBottomWidth: 1,
  borderBottomColor: Styles.color.grey.four,
  paddingBottom: '$4',
  marginBottom: '$4',
  focusable: true,
});

export const CardText = Text.withConfig({
  fontSize: 'sm',
  margin: 0,
});

export const FeeDeliveryItem = Text.withConfig({
  fontSize: 'sm',
  margin: 0,
  textTransform: Styles.textTransform.headlines,
});

export const TotalRow = HStack.withConfig({
  justifyContent: 'space-between',

  _text: {
    lineHeight: 'xl',
  },
  focusable: true,
});

export const FixedMapWindow = Box.withConfig({
  height: '1/5',
  width: 'full',
});

export const StyledOrderIssues = Box.withConfig({
  backgroundColor: theme.token('background-pattern'),
  alignItems: {
    base: 'center',
    md: 'flex-start',
  },
  marginLeft: {
    base: 'auto',
    md: '$4',
  },
  marginRight: {
    base: 'auto',
    md: '$4',
  },
  width: {
    base: '90%',
    md: 'auto',
  },
  paddingTop: {
    base: '$5',
    md: '$2',
  },
  padding: '$5',
  marginBottom: '$4',
  borderRadius: Styles.borderRadius,
  style: {
    shadowColor: Styles.shadowColor,
    shadowOffset: {
      width: 0,
      height: 0.5,
    },
    shadowRadius: 1.5,
    shadowOpacity: 1,
  },
  maxWidth: {
    base: '$96',
    md: 'auto',
  },
  focusable: true,
});

export const DeliveryConfirmationRoot = Box.withConfig({
  width: 'full',
});
export const ScrollContainer = Box.withConfig({ marginBottom: 'full' });
